import React, { useState, useEffect } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import bg3 from '../../assets/bg3.png';

const testimonials = [
  {
    id: 1,
    name: 'ANN LUBIN',
    title: 'CO-FOUNDER',
    text: "Using this app has been a game-changer for our team. It's intuitive, reliable, and has helped us streamline operations like never before.",
  },
  {
    id: 2,
    name: 'JOHN SMITH',
    title: 'CEO',
    text: 'We’ve tried several platforms before, but nothing compares. The app’s clean interface and powerful features make it an essential tool for our business.',
  },
  {
    id: 3,
    name: 'SARAH JOHNSON',
    title: 'CTO',
    text: 'The onboarding process was incredibly smooth. Within minutes, our entire team was up and running. Highly recommend this app to any tech-forward company.',
  },
  {
    id: 4,
    name: 'MIKE DAVIS',
    title: 'DESIGNER',
    text: 'I love how user-friendly the interface is. As a designer, I appreciate the attention to detail and the overall UX of the app.',
  },
  {
    id: 5,
    name: 'LISA BROWN',
    title: 'MANAGER',
    text: 'Managing projects and tasks has never been easier. The app keeps everything organized and accessible, even on the go!',
  },
];

export default function TestimonialCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1000
  );

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const isMobile = windowWidth < 600;
  const isTablet = windowWidth >= 600 && windowWidth < 900;

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: isMobile ? '20px 10px' : '40px 20px',
    color: 'white',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    textAlign: 'center',
    backgroundImage: `url(${bg3})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  const headingStyle = {
    fontWeight: '700',
    letterSpacing: '2px',
    fontSize: isMobile ? '1.8rem' : isTablet ? '2.2rem' : '2.5rem',
    marginBottom: isMobile ? '8px' : '10px',
  };

  const descriptionStyle = {
    maxWidth: isMobile ? '90%' : '800px',
    lineHeight: 1.6,
    marginBottom: isMobile ? '30px' : '40px',
    opacity: 0.9,
    fontSize: isMobile ? '0.9rem' : isTablet ? '1rem' : '1.1rem',
  };

  const carouselStyle = {
    position: 'relative',
    width: '100%',
    maxWidth: isMobile ? '320px' : isTablet ? '600px' : '900px',
    height: isMobile ? '280px' : isTablet ? '320px' : '350px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'visible',
    overflowY: 'visible',
    marginTop: isMobile ? '40px' : isTablet ? '30px' : '20px',
    marginBottom: isMobile ? '40px' : isTablet ? '30px' : '20px',
  };

  const cardWidth = isMobile ? 280 : isTablet ? 400 : 480;
  const cardMinHeight = isMobile ? 180 : isTablet ? 220 : 270;
  const sideCardOpacity = isMobile ? 0.5 : 0.7;
  const sideCardScale = isMobile ? 0.8 : 0.9;
  const paddingPx = isMobile ? 20 : isTablet ? 30 : 40;

  const cardBaseStyle = {
    position: 'absolute',
    width: cardWidth,
    minHeight: cardMinHeight,
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: paddingPx,
    boxShadow: '0 15px 35px rgba(0,0,0,0.15)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#333',
    cursor: 'pointer',
    transition: 'all 0.5s ease',
    boxSizing: 'border-box',
    overflowWrap: 'break-word',
  };

  const avatarIconStyle = {
    fontSize: isMobile ? 60 : isTablet ? 70 : 80,
    color: '#8b5cf6',
    marginBottom: 15,
  };

  const nameStyle = {
    fontWeight: '700',
    fontSize: isMobile ? '1.1rem' : isTablet ? '1.3rem' : '1.4rem',
    marginBottom: '5px',
  };

  const titleStyle = {
    color: '#777',
    fontSize: isMobile ? '0.85rem' : isTablet ? '0.95rem' : '1rem',
    marginBottom: '20px',
  };

  const textStyle = {
    fontSize: isMobile ? '0.85rem' : isTablet ? '0.95rem' : '1rem',
    lineHeight: 1.5,
    color: '#555',
  };

  const paginationStyle = {
    display: 'flex',
    gap: isMobile ? '10px' : '12px',
    marginTop: isMobile ? '30px' : '40px',
    justifyContent: 'center',
  };

  const dotSize = isMobile ? 12 : 14;

  const dotStyle = (active) => ({
    width: dotSize,
    height: dotSize,
    borderRadius: '50%',
    backgroundColor: active ? 'white' : 'rgba(255,255,255,0.5)',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  });

  const getPositionStyles = (cardIndex) => {
    const total = testimonials.length;
    let diff = cardIndex - currentIndex;

    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;

    if (diff === 0) {
      return {
        ...cardBaseStyle,
        left: '50%',
        transform: 'translateX(-50%) scale(1)',
        opacity: 1,
        zIndex: 3,
      };
    }
    if (diff === -1) {
      return {
        ...cardBaseStyle,
        left: isMobile ? '5%' : '10%',
        transform: `translateX(0) scale(${sideCardScale})`,
        opacity: sideCardOpacity,
        zIndex: 2,
      };
    }
    if (diff === 1) {
      return {
        ...cardBaseStyle,
        right: isMobile ? '5%' : '10%',
        left: 'auto',
        transform: `translateX(0) scale(${sideCardScale})`,
        opacity: sideCardOpacity,
        zIndex: 2,
      };
    }

    return { display: 'none' };
  };

  const handleCardClick = (cardIndex) => {
    const total = testimonials.length;
    let diff = cardIndex - currentIndex;

    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;

    if (diff === -1) {
      setCurrentIndex(currentIndex === 0 ? total - 1 : currentIndex - 1);
    } else if (diff === 1) {
      setCurrentIndex((currentIndex + 1) % total);
    }
  };

  return (
    <div style={containerStyle}>
      {/* <Container maxWidth="lg" sx={{ marginBottom: "20px" }}>
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              color: "white",
              fontWeight: 700,
              fontSize: { xs: "1.8rem", sm: "2rem", md: "2.5rem" },
              letterSpacing: "0.5px",
              mb: 3,
            }}
          >
            HOW TO USE THE APP PERFECTLY
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: { xs: "0.95rem", sm: "1.05rem", md: "1.1rem" },
              lineHeight: 1.6,
              maxWidth: { xs: "90%", sm: "600px" },
              mx: "auto",
            }}
          >
            Watch this short video to discover how to make the most of our app.
            Learn how to navigate the features, customize your settings, and
            streamline your workflow efficiently.
          </Typography>
        </Box>

        <VideoCard>
          <VideoContainer>
            <PlayButton onClick={() => window.open("https://your-video-url.com", "_blank")}>
              <PlayArrowIcon sx={{ fontSize: { xs: 30, sm: 35, md: 40 } }} />
            </PlayButton>
          </VideoContainer>
        </VideoCard>
      </Container> */}

      <h2 style={headingStyle}>OUR HAPPY CUSTOMERS</h2>
      <p style={descriptionStyle}>
        Here's what our customers are saying about their experience. From business owners to tech
        enthusiasts, users love how our app has improved their productivity and simplified their
        lives.
      </p>

      <div style={carouselStyle}>
        {testimonials.map((testimonial, idx) => (
          <div
            key={testimonial.id}
            style={getPositionStyles(idx)}
            onClick={() => handleCardClick(idx)}
            aria-hidden={idx !== currentIndex}
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') handleCardClick(idx);
            }}
          >
            <FaUserCircle style={avatarIconStyle} />
            <h3 style={nameStyle}>{testimonial.name}</h3>
            <h4 style={titleStyle}>{testimonial.title}</h4>
            <p style={textStyle}>{testimonial.text}</p>
          </div>
        ))}
      </div>

      <div style={paginationStyle}>
        {testimonials.map((_, idx) => (
          <div
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            style={dotStyle(idx === currentIndex)}
            aria-label={`Go to testimonial ${idx + 1}`}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') setCurrentIndex(idx);
            }}
          />
        ))}
      </div>
    </div>
  );
}
